import { useQuery } from "@tanstack/react-query";
import { getSimpleStepSection } from "../../api/apiSimpleStepSection";

export const useGetSimpleStepSection = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["simple-step-section"],
        queryFn: getSimpleStepSection,
    });

    return {
        simpleStepSection: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
